var makeString = require('./helper/makeString');
var toPositive = require('./helper/toPositive');

module.exports = function startsWith(str, starts, position) {
  str = makeString(str);
  starts = '' + starts;
  position = position == null ? 0 : Math.min(toPositive(position), str.length);
  return str.lastIndexOf(starts, position) === position;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/underscore.string/startsWith.js
 ** module id = 1101
 ** module chunks = 0
 **/